import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { UpsertPartnerNotificationRecipientsInput, UpsertPartnerNotificationRecipientsPayload } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPSERT_PARTNER_NOTIFICATION_RECIPIENTS = gql`
    mutation upsertPartnerNotificationRecipients($input: UpsertPartnerNotificationRecipientsInput!){
        upsertPartnerNotificationRecipients(input: $input){
            message
            errors {
                code
                message
            }
            result
            partnerNotificationRecipients {
                id
            }
        }
    }
`;

export const mutationUpsertPartnerNotificationRecipients = async (
    client: ApolloClient<NormalizedCacheObject>,
    args: {
        input: UpsertPartnerNotificationRecipientsInput
    }
): Promise<UpsertPartnerNotificationRecipientsPayload | undefined> => {
    const {
        partnerId,
        description,
        id,
        notificationType,
        receivesErrors,
        receivesNotifications,
        recipients
    } = args.input;

    const { data, errors } = await client.mutate<{ upsertPartnerNotificationRecipients: UpsertPartnerNotificationRecipientsPayload }>({
        variables: {
            input: {
                partnerId,
                description,
                id,
                notificationType,
                receivesErrors,
                receivesNotifications,
                recipients
            }
        },
        mutation: MUTATION_UPSERT_PARTNER_NOTIFICATION_RECIPIENTS
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred during the PartnerNotificationRecipients save.');
    }
    if (data && data.upsertPartnerNotificationRecipients) {
        return data.upsertPartnerNotificationRecipients;
    }
    return undefined;
};